import { render, staticRenderFns } from "./CompanySettingsNavbar.vue?vue&type=template&id=38899a2e&scoped=true"
import script from "./CompanySettingsNavbar.vue?vue&type=script&lang=js"
export * from "./CompanySettingsNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38899a2e",
  null
  
)

export default component.exports